import { useState } from 'react';

import CopyAllIcon from '@mui/icons-material/CopyAll';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { IconButton } from 'shared/mui/IconButtons';
import { Tooltip } from 'shared/mui/Tooltip';

import { useGetOrderCopyMainData } from './hooks/useGetOrderCopyMainData';

export const OrdersShowCommonInfoMainCopyButton = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { copyData } = useGetOrderCopyMainData();

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipText, setTooltipText] = useState('');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(copyData);
      setTooltipText(translate('app.buttons.copied'));
      setTooltipOpen(true);
    } catch (e: unknown) {
      setTooltipText(translate('app.buttons.copyFailed'));
      setTooltipOpen(true);
    }
  };

  return (
    <Tooltip disableHoverListener open={tooltipOpen} title={tooltipText}>
      <IconButton onClick={handleCopy} size="medium" sx={{ padding: '4px' }}>
        <CopyAllIcon sx={{ fontSize: 'inherit' }} />
      </IconButton>
    </Tooltip>
  );
};
